import React ,{ useEffect,useState, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { ORG_GET_ESTIMATE_LIST, ORG_GET_INVOICE_LIST, ORG_GET_RECEIPT_LIST,ORG_GET_RECURRUNG_INVOICE_LIST } from '../../../../ApiServices/BaseURL';
import { postData,getData } from "../../../../ApiServices/ApiService";
import { useTheme } from "../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../Utils/Exception";

const BillingReceiptEstimateController = () => {

    const { state } = useLocation();
    const { setIsLoginPopup } = useTheme();
    const [serviceEstimateList, setServiceEstimateList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [invoiceList, setInvoiceList] = useState([]);
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [invoiceError, setInvoiceError] = useState('');
    const [hasMoreServerData, setHasMoreServerData] = useState(true);
    const [offset, setOffset] = useState(0);
    const [isFilterData,setIsFilterData] = useState (false)

    const [recurringInvoiceList, setRecurringInvoiceList] = useState([]);
    const [recurringInvoiceLoading, setRecurringInvoiceLoading] = useState(false);
    const [recurringInvoiceError, setRecurringInvoiceError] = useState('');

    const [receiptList, setReceiptList] = useState([]);
    const [receiptLoading, setReceiptLoading] = useState(false);
    const [receiptError, setReceiptError] = useState('');
    const [hasMoreServerDataReceipt, setHasMoreServerDataReceipt] = useState(true);
    const [offsetReceipt, setOffsetReceipt] = useState(0);
    const [isFilterDataReceipt,setIsFilterDataReceipt] = useState (false)

    const [backDateApprovalList, setBackDateApprovalList] = useState([]);
    const [backDateApprovalLoading, setBackDateApprovalLoading] = useState(false);
    const [backDateApprovalError, setBackDateApprovalError] = useState('');

     const [hasMoreServerDataEstimate, setHasMoreServerDataEstimate] = useState(true);
    const [offsetEstimate, setOffsetEstimate] = useState(0);
    const [isFilterDataEstimate,setIsFilterDataEstimate] = useState (false)

    const pageName = "BillingReceiptEstimateController";
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(()=>{
        fetchServiceEstimateList();
        fetchInvoiceList();
        fetchReceiptList();
        fetchRecurringInvoiceList();
        fetchBackDateApprovalList();
    },[])

      const fetchServiceEstimateList =async (currentOffset = 0)=>{
        try {
            //console.log('get categoty')
            setLoading(true);
            setIsFilterDataEstimate(false)
            setError('');
            if(currentOffset === 0){
              setServiceEstimateList([]);
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            const payLoad = {
              "emp_id_auth": storedUserInfo?.emp_id,
              "offset": currentOffset,
              "query_type": state?.selectedTab === 0 && state?.clientId && state?.filterKey ? "estimate_account_get_info" : "list",
              ...(state?.selectedTab === 0 && state?.clientId && state?.filterKey && { query_type_name: state?.filterKey, client_id: state?.clientId }),
            }
        
            // Make the API call
            const response = await postData(ORG_GET_ESTIMATE_LIST,payLoad);
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    // setServiceEstimateList(responseData?.dataJ);
                    const newEstimatelist = responseData?.dataJ || [];
                    setServiceEstimateList(prev => [...prev, ...newEstimatelist]);
                    setOffsetEstimate(responseData?.new_offset);
                    setHasMoreServerDataEstimate(!responseData?.is_data_end);
                  } else {
                    setError(responseData?.info || 'Data Not Found');
                    logFrontendException(storedUserId, pageName, "fetchServiceEstimateList", responseData?.info || '');
                    setHasMoreServerDataEstimate(false);
                  }
                } else {
                  setError(responseData?.info || 'Failed to fetch service estimate. Please try again.');
                  logFrontendException(storedUserId, pageName, "fetchServiceEstimateList", responseData?.info || '');
                  setHasMoreServerDataEstimate(false);
                }
              } else {
                setError(responseData?.info || 'Failed to fetch service estimate. Status code error.');
                logFrontendException(storedUserId, pageName, "fetchServiceEstimateList", responseData?.info || '');
                setHasMoreServerDataEstimate(false);
              }
            } 
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              
                setError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "fetchServiceEstimateList", response || '');
                setHasMoreServerDataEstimate(false);
                // Optionally, redirect to the login page or refresh the token
                // Example: redirectToLogin();
              
              setIsLoginPopup(true)
            } 
            
            // Unexpected or network-related errors
            else {
              setError('Unexpected error occurred. Please try again later.');
              logFrontendException(storedUserId, pageName, "fetchServiceEstimateList", response || '');
              setHasMoreServerDataEstimate(false);
            }
          } catch (error) {
            
              setError(`Failed to fetch service estimate. Please check your network connection and try again.`);
              logFrontendException(storedUserId, pageName, "fetchServiceEstimateList-catch", error || '');
              setHasMoreServerDataEstimate(false)
            
          } finally {
            setLoading(false);
          }
      }

      const fetchInvoiceList =async (currentOffset = 0)=>{
        try {
            //console.log('get categoty')
            setInvoiceLoading(true);
            // setInvoiceList([]);
            setInvoiceError('');
            setIsFilterData(false);
            if(currentOffset === 0){
              setInvoiceList([])
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
              "emp_id_auth": storedUserInfo?.emp_id,
              "query_type": state?.selectedTab === 1 && state?.clientId && state?.filterKey ? "invoice_account_get_info" : "list",
              "list_type": "invoice",
              "offset": currentOffset,
              ...(state?.selectedTab === 1 && state?.clientId && state?.filterKey && { query_type_name: state?.filterKey, client_id: state?.clientId }),
            }
            // Make the API call
            const response = await postData(ORG_GET_INVOICE_LIST,payLoad);
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                     const newInvoiceList = responseData?.dataJ || [];
                    setInvoiceList(prev => [...prev, ...newInvoiceList]);
                    setOffset(responseData?.new_offset);
                    setHasMoreServerData(!responseData?.is_data_end);
                  } else {
                    setInvoiceError(responseData?.info || 'Data Not Found');
                    setHasMoreServerData(false);
                    logFrontendException(storedUserId, pageName, "fetchInvoiceList", responseData?.info || '');
                  }
                } else {
                  setInvoiceError(responseData?.info || 'Failed to fetch Invoice list. Please try again.');
                  setHasMoreServerData(false);
                  logFrontendException(storedUserId, pageName, "fetchInvoiceList", responseData?.info || '');
                }
              } else {
                setInvoiceError(responseData?.info || 'Failed to fetch Invoice list. Status code error.');
                setHasMoreServerData(false);
                logFrontendException(storedUserId, pageName, "fetchInvoiceList", responseData?.info || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if ([400, 401, 403].includes(response?.status)) {
              setInvoiceError('Unauthorized access. Your session may have expired. Please log in again.');
              setIsLoginPopup(true);
              setHasMoreServerData(false);
              logFrontendException(storedUserId, pageName, "fetchInvoiceList", response || '');
              
            }  
            // Unexpected or network-related errors
            else {
              setInvoiceError('Unexpected error occurred. Please try again later.');
              setHasMoreServerData(false);
              logFrontendException(storedUserId, pageName, "fetchInvoiceList", response || '');
            }
          } catch (error) {
            // Handle various error scenarios            
            setInvoiceError(`Failed to fetch Invoice list. Please check your network connection and try again.`);
            setHasMoreServerData(false);
            logFrontendException(storedUserId, pageName, "fetchInvoiceList-catch", error || '');
          } finally {
            setInvoiceLoading(false);
          }
      }

      const fetchRecurringInvoiceList =async ()=>{
        try {
            //console.log('get categoty')
            setRecurringInvoiceLoading(true);
            setRecurringInvoiceList([]);
            setRecurringInvoiceError('');
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
              "emp_id_auth": storedUserInfo?.emp_id,
              "action": 'recurring_inv_list',
              "query_type": state?.selectedTab === 2 && state?.clientId && state?.filterKey ? "invoice_account_get_info" : "list",
              ...(state?.selectedTab === 2 && state?.clientId && state?.filterKey && { query_type_name: state?.filterKey, client_id: state?.clientId }),
            }
            // Make the API call
            const response = await postData(ORG_GET_RECURRUNG_INVOICE_LIST,payLoad);
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    setRecurringInvoiceList(responseData?.dataJ);
                  } else {
                    setRecurringInvoiceError(responseData?.info || 'Data Not Found');
                    logFrontendException(storedUserId, pageName, "fetchRecurringInvoiceList", responseData?.info || '');
                  }
                } else {
                  setRecurringInvoiceError(responseData?.info || 'Failed to fetch Invoice list. Please try again.');
                  logFrontendException(storedUserId, pageName, "fetchRecurringInvoiceList", responseData?.info || '');
                }
              } else {
                setRecurringInvoiceError(responseData?.info || 'Failed to fetch Invoice list. Status code error.');
                logFrontendException(storedUserId, pageName, "fetchRecurringInvoiceList", responseData?.info || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
             setRecurringInvoiceError('Unauthorized access. Your session may have expired. Please log in again.');
             logFrontendException(storedUserId, pageName, "fetchRecurringInvoiceList", response || '');
           
            } 
            else {
              setRecurringInvoiceError('Unexpected error occurred. Please try again later.');
              logFrontendException(storedUserId, pageName, "fetchRecurringInvoiceList", responseData?.info || '');
            }
          } catch (error) {
            // Handle various error scenarios            
            setRecurringInvoiceError(`Failed to fetch Invoice list. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchRecurringInvoiceList-catch", error || '');
          } finally {
            setRecurringInvoiceLoading(false);
          }
      }

      const fetchReceiptList =async (currentOffset = 0)=>{
        try {
            //console.log('get categoty')
            setReceiptLoading(true);
            setReceiptError('');
            setIsFilterDataReceipt(false);
            if(currentOffset === 0){
              setReceiptList([])
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
              "emp_id_auth": storedUserInfo?.emp_id,
              "offset":currentOffset,
              "query_type": state?.selectedTab === 3 && state?.clientId && state?.filterKey ? "receipt_account_get_info" : "list",
              ...(state?.selectedTab === 3 && state?.clientId && state?.filterKey && { query_type_name: state?.filterKey, client_id: state?.clientId }),
            }
            // Make the API call
            const response = await postData(ORG_GET_RECEIPT_LIST,payLoad);
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    const newReceipts = responseData?.dataJ || [];
                    setReceiptList(prev => [...prev, ...newReceipts]);
                    // setReceiptList(responseData?.dataJ);
                    setOffsetReceipt(responseData?.new_offset);
                    setHasMoreServerDataReceipt(!responseData?.is_data_end);
                  } else {
                    setReceiptError(responseData?.info || 'No receipts available.');
                    logFrontendException(storedUserId, pageName, "fetchReceiptList", responseData?.info || '');
                    setHasMoreServerDataReceipt(false);
                  }
                } else {
                  setReceiptError(responseData?.info || 'Failed to fetch receipt list. Please try again.');
                  setHasMoreServerDataReceipt(false);
                  logFrontendException(storedUserId, pageName, "fetchReceiptList", responseData?.info || '');
                }
              } else {
                setReceiptError(responseData?.info || 'Failed to fetch receipt list. Status code error.');
                setHasMoreServerDataReceipt(false);
                logFrontendException(storedUserId, pageName, "fetchReceiptList", responseData?.info || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if ([400, 401, 403].includes(response?.status)) {
              setReceiptError('Unauthorized access. Your session may have expired. Please log in again.');
              setIsLoginPopup(true);
              setHasMoreServerDataReceipt(false);
              logFrontendException(storedUserId, pageName, "fetchReceiptList", response || '');
                
            } 
            
            // Unexpected or network-related errors
            else {
              setReceiptError('Unexpected error occurred. Please try again later.');
              setHasMoreServerDataReceipt(false);
              logFrontendException(storedUserId, pageName, "fetchReceiptList", response || '');
            }
          } catch (error) {
            // Handle various error scenarios            
            setReceiptError(`Failed to fetch receipt list. Please check your network connection and try again.`);
            setHasMoreServerDataReceipt(false);
            logFrontendException(storedUserId, pageName, "fetchReceiptList-catch", error || '');
          } finally {
            setReceiptLoading(false);
          }
      }

      const fetchBackDateApprovalList  =async ()=>{
        try {
            //console.log('get categoty')
            setBackDateApprovalLoading(true);
            setBackDateApprovalList([]);
            setBackDateApprovalError('');
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const userRole = storedUserInfo?.emp_role;
            const payLoad = {
              "emp_id_auth": storedUserInfo?.emp_id,
              "query_type": state?.selectedTab === 1 && state?.clientId && state?.filterKey ? "invoice_account_get_info" : "list",
              "list_type": "approval",
              ...(state?.selectedTab === 4 && state?.clientId && state?.filterKey && { query_type_name: state?.filterKey, client_id: state?.clientId }),
            }
            let response = null;
            let responseData = null;
            // Make the API call
            if(userRole !== "Accountant"){
              response = await postData(ORG_GET_INVOICE_LIST,payLoad);
              responseData = await response.json();
            }
            else{
              setBackDateApprovalError('No data to display at the moment');
              return;
            }
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    setBackDateApprovalList(responseData?.dataJ);
                  } else {
                    setBackDateApprovalError(responseData?.info || 'Data Not Found');
                    logFrontendException(storedUserId, pageName, "fetchReceiptList", responseData?.info || '');
                  }
                } else {
                  setBackDateApprovalError(responseData?.info || 'Failed to fetch Approval list. Please try again.');
                  logFrontendException(storedUserId, pageName, "fetchReceiptList", responseData?.info || '');
                }
              } else {
                setBackDateApprovalError(responseData?.info || 'Failed to fetch Approval list. Status code error.');
                logFrontendException(storedUserId, pageName, "fetchReceiptList", responseData?.info || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              
                setBackDateApprovalError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "fetchReceiptList", response || '');
                // Optionally, redirect to the login page or refresh the token
                // Example: redirectToLogin();
              
            } 
           
            // Unexpected or network-related errors
            else {
              setBackDateApprovalError('Unexpected error occurred. Please try again later.');
              logFrontendException(storedUserId, pageName, "fetchReceiptList", response || '');
            }
          } catch (error) {
            // Handle various error scenarios            
            setBackDateApprovalError(`Failed to fetch Approval list. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchReceiptList-catch", error || '');
          } finally {
            setBackDateApprovalLoading(false);
          }
      }

      const serviceEstimateRefresh = (offsetEstimate)=>{
        if (hasMoreServerDataEstimate && !loading) {
        fetchServiceEstimateList(offsetEstimate ? offsetEstimate :0);
        }
        // fetchServiceEstimateList();
      }

      const invoiceRefresh = (offset)=>{
         if (hasMoreServerData && !invoiceLoading) {
        fetchInvoiceList(offset ? offset :0);
      }
      }

      const receiptRefresh = (offsetReceipt) => {
        if (hasMoreServerDataReceipt && !receiptLoading) {
        fetchReceiptList(offsetReceipt ? offsetReceipt :0);
        }
      }

      const recurringInvoiceRefresh = ()=>{
        fetchRecurringInvoiceList();
      }

      const backDateApprovalListRefresh = ()=>{
        fetchInvoiceList();
        fetchBackDateApprovalList();
      }

      return {
        serviceEstimateList,
        loading,
        error, 
        serviceEstimateRefresh, 
        invoiceList,
        invoiceError,
        invoiceLoading,invoiceRefresh,
        receiptList,
        receiptError, receiptLoading,
        receiptRefresh,
        recurringInvoiceList,recurringInvoiceLoading,recurringInvoiceError,recurringInvoiceRefresh,
        backDateApprovalList,
        backDateApprovalLoading,
        backDateApprovalError,
        backDateApprovalListRefresh,
        setError,
        offset,
        hasMoreServerData,isFilterData,setIsFilterData,
        offsetReceipt,hasMoreServerDataReceipt,isFilterDataReceipt,setIsFilterDataReceipt,
        offsetEstimate,
        hasMoreServerDataEstimate,
        isFilterDataEstimate,
        setIsFilterDataEstimate
      }

}

export default BillingReceiptEstimateController;